import moment from "moment"

export const FORM_MAP = {
    RANGE_TIME: 'rangeTime',
    RANGE_TIME_DIFF: 'diff',
    RANGE_TIME_TYPE: 'timeType',
    REGION: 'region',
    SYSTEM: 'system',
    STATISTIC_DATE: 'statisticDate',
    CONTRAST_DATE: 'contrastDate',
    STATISTIC_DATE_TYPE: 'statisticDate_timeType',
    CONTRAST_DATE_TYPE: 'contrastDate_timeType',
    CHANNEL: 'channel',
    ZONE: 'zone',
    RANGE_TIME_TIME_TYPE:'timeType',
    LANGUAGE: 'language',
    RANGE_DEFAULT:'rangeDefualt'
  }

export const TIME_TAB: any = [{ tabName: 'Day' }, { tabName: 'Week' }, { tabName: 'Month' }]
export const TIMETYPETODATE = {
  Day: 'date',
  Week: 'week',
  Month: 'month',
}

export const timeRange: any = {
    Day: [moment().subtract(14, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
    Week: [
      moment().week(moment().week() - 6).startOf('isoWeek').format('YYYY-MM-DD'),
      moment().week(moment().week() - 1).endOf('isoWeek').format('YYYY-MM-DD')
    ],
    Month: [
      moment().month(moment().month() - 6).startOf('month').format('YYYY-MM-DD'),
      moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD')
    ],
  }

export const contrastRange: any = {
  Day: [moment().subtract(28, 'day').format('YYYY-MM-DD'), moment().subtract(15, 'day').format('YYYY-MM-DD')],
  Week: [
    moment().week(moment().week() - 12).startOf('isoWeek').format('YYYY-MM-DD'),
    moment().week(moment().week() - 7).endOf('isoWeek').format('YYYY-MM-DD')
  ],
  Month: [
    moment().month(moment().month() - 12).startOf('month').format('YYYY-MM-DD'),
    moment().month(moment().month() - 7).endOf('month').format('YYYY-MM-DD')
  ],
}

export const PUBLIC_STATE = {
    [FORM_MAP.RANGE_TIME_TYPE]: 'Day',
    [FORM_MAP.RANGE_TIME]: timeRange.Day,
    [FORM_MAP.STATISTIC_DATE]: timeRange.Day,
    [FORM_MAP.CONTRAST_DATE]: contrastRange.Day,
    [FORM_MAP.STATISTIC_DATE_TYPE]: 'Day',
    [FORM_MAP.CONTRAST_DATE_TYPE]: 'Day',
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    [FORM_MAP.REGION]: {
      regions: [],
      markets: ['255'],
      region_type: 'market'
    },
    [FORM_MAP.SYSTEM]: ['255'],
    [FORM_MAP.CHANNEL]: ['255'],
    [FORM_MAP.ZONE]: ['255'],
  [FORM_MAP.LANGUAGE]: ['255']
  } as any

  export const COUNTRY_TIME_RANG_DEFAULT: any = {
    Day: [moment().subtract(14, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
    Week: [
      moment().week(moment().week() - 6).startOf('isoWeek').format('YYYY-MM-DD'),
      moment().week(moment().week() - 1).endOf('isoWeek').format('YYYY-MM-DD')
    ],
    Month: [
      moment().month(moment().month() - 6).startOf('month').format('YYYY-MM-DD'),
      moment().month(moment().month() - 1).endOf('month').format('YYYY-MM-DD')
    ],
  }

export const COUNTRY_FILTER_VALUE_DEFAULT = {
    [FORM_MAP.RANGE_TIME_TYPE]: 'Day',
    [FORM_MAP.RANGE_TIME]: COUNTRY_TIME_RANG_DEFAULT.Day,
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    [FORM_MAP.REGION]: {
      regions: [],
      markets: ['255'],
      region_type: 'market'
    },
    [FORM_MAP.SYSTEM]: ['255'],
    [FORM_MAP.CHANNEL]: ['255'],
    [FORM_MAP.ZONE]: ['255'],
    [FORM_MAP.LANGUAGE]: ['255']
  } as any



  export const topDataInit = {
    statistics:[
      {
        type:'sum',
        data:{value: "", dod: "", sdlw: "", rate: ""}
      },
      {
        type:'avg',
        data:{value: "", dod: "", sdlw: "", rate: ""}
      }
  ],
    contrast:[
      {
        type:'sum',
        data:{value: "", dod: "", sdlw: "", rate: ""}
      },
      {
        type:'avg',
        data:{value: "", dod: "", sdlw: "", rate: ""}
      }
    ]
  }
// 宽表相关的本地文本
export const textLocalConfig = [
  {
    id: "common_date",
    key: "date",
  },
  {
    id: "common_contrast",
    key: 'contrast'
  },
  {
    id: "comparison_analysis_date_comparison_key_metrics_comparison",
    key: "dateTitle"
  },
  {
    id: "comparison_analysis_country_comparison_key_metrics_ranking",
    key: "countryTitle"
  },
  {
    id: "common_Zone",
    key: "zone",
  },
  {
    id: "common_Region",
    key: "region",
  },
  {
    id: "common_Country",
    key: "country",
  },
  {
    id: "common_System",
    key: "system",
  },
  {
    id: "common_Channel",
    key: "channel",
  },
  {
    id: "common_Bundle",
    key: "bundle",
  },
  {
    id: "common_Sum",
    key: "sum",
  },
  {
    id: "common_Max",
    key: "max",
  },
  {
    id: "common_Min",
    key: "min",
  },
  {
    id: "common_Average(remove_Null)",
    key: "avg_no_null",
  },
  {
    id: "common_Average(remove_Null&0)",
    key: "avg_no_null_zero"
  },
  {
    id: "common_Count",
    key: "count"
  },
  {
    id: "common_Language",
    key: "language"
  },
  // 夜莺时间对比 留存追踪对比宽表
  {
    id: "common_Average",
    key: "avg",
  },
  {
    id: "common_Churn_level",
    key: "churn_level"
  },
]

export const dailyTimezoneTextLocalConfig = [
  {
    id: "daily_by_timezone_Key_Metrics_Comparison",
    key: "tableTitle"
  }
]

export const VALUE_TYPE_RADIO_OPTIONS = ["value_only", "show_dod", "show_sdlw"]

// 国家对比页面 宽表上方 Segement选项
export const TABLE_SEGEMENT_OPTIONS = {
  'Day' : ["value_only", "show_dod", "show_sdlw"],
  'Week': ["value_only", "show_wow", "show_swlm"],
  'Month': ["value_only", "show_mom", "show_smly"]
}